import Clickable from '/components/Clickable';
import Image from '/components/Image';
import PropTypes from 'prop-types';
import classNames from '/utils/class-names';

const ProductConfigs = ({
	packConfig,
	productFilters = {},
	setActiveProductType,
	updateSelectedProductConfig,
}) => {
	if (!packConfig?.productConfigs || packConfig.productConfigs.length <= 1) {
		return null;
	}

	const updateSelection = (productConfigIndex, productType) => {
		updateSelectedProductConfig(productConfigIndex);
		setActiveProductType(productType);
	};

	return (
		<div className="flex w-full">
			{packConfig.productConfigs.map((productConfig, productConfigIndex) => {
				return (
					<Clickable
						className={classNames(
							'border-b-2 flex-grow pb-2 items-center flex flex-col justify-between first:ml-4 first:mr-2 last:mr-4 last:ml-2',
							productFilters.productType === productConfig.productType?.productType
								? 'border-primary'
								: 'border-white',
						)}
						key={productConfigIndex}
						onClick={() => {
							updateSelection(productConfigIndex, productConfig.productType?.productType);
						}}>
						<Image
							src={
								productFilters.productType === productConfig.productType?.productType
									? productConfig.productType.selectedImg
									: productConfig.productType.img
							}
							alt="product icon"
							height={50}
							width={50}
							objectFite="contain"
						/>
						{productConfig.productType.name} - {productConfig.size}
					</Clickable>
				);
			})}
		</div>
	);
};

ProductConfigs.propTypes = {
	packConfig: PropTypes.object,
	productFilters: PropTypes.object,
	setActiveProductType: PropTypes.func,
	updateSelectedProductConfig: PropTypes.func,
};

export default ProductConfigs;
